const actions = {
    GET_MONTAJES_REQUEST:    'GET_MONTAJES_REQUEST',
    GET_MONTAJES_SUCCESS:    'GET_MONTAJES_SUCCESS',
    GET_MONTAJE_REQUEST:     'GET_MONTAJE_REQUEST',
    GET_MONTAJE_SUCCESS:     'GET_MONTAJE_SUCCESS',
    CREATE_MONTAJE_REQUEST:  'CREATE_MONTAJE_REQUEST',
    CREATE_MONTAJE_SUCCESS:  'CREATE_MONTAJE_SUCCESS',
    UPDATE_MONTAJE_REQUEST:  'UPDATE_MONTAJE_REQUEST',
    UPDATE_MONTAJE_SUCCESS:  'UPDATE_MONTAJE_SUCCESS',
    ANULAR_MONTAJE_REQUEST:  'ANULAR_MONTAJE_REQUEST',
    ANULAR_MONTAJE_SUCCESS:  'ANULAR_MONTAJE_SUCCESS',
    PREVIEW_CONSUMO_REQUEST: 'PREVIEW_CONSUMO_REQUEST',
    PREVIEW_CONSUMO_SUCCESS: 'PREVIEW_CONSUMO_SUCCESS',
    CONFIRMAR_MONTAJE_REQUEST: 'CONFIRMAR_MONTAJE_REQUEST',
    CONFIRMAR_MONTAJE_SUCCESS: 'CONFIRMAR_MONTAJE_SUCCESS',
    SET_LOADING:             'MONTAJES_SET_LOADING',

    getMontajes:       (query)   => ({ type: actions.GET_MONTAJES_REQUEST, query }),
    getMontaje:        (id)      => ({ type: actions.GET_MONTAJE_REQUEST, id }),
    createMontaje:     (data)    => ({ type: actions.CREATE_MONTAJE_REQUEST, payload: data }),
    updateMontaje:     (data)    => ({ type: actions.UPDATE_MONTAJE_REQUEST, payload: data }),
    anularMontaje:     (id)      => ({ type: actions.ANULAR_MONTAJE_REQUEST, id }),
    previewConsumo:    (id)      => ({ type: actions.PREVIEW_CONSUMO_REQUEST, id }),
    confirmarMontaje:  (id, data) => ({ type: actions.CONFIRMAR_MONTAJE_REQUEST, id, payload: data }),
};

export default actions;
